export const LANDLORDS = "LANDLORDS";

